import { word } from "@modules/core/utils/i18n"
import { Text } from "@/components/ui/baseUi/text"

type ErrorCardProps = {
  title?: string
  error?: Error
} & React.ComponentProps<"div">

export function ErrorCard({ title, error, ...props }: ErrorCardProps) {
  return (
    <div className="card flex flex-col gap-3" {...props}>
      <Text fontStyle="HM" className="flex items-center justify-center">
        {title ?? word("global.error.default")}
      </Text>
      {error && <Text>{error.message}</Text>}
    </div>
  )
}
